import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { getInvalidFields, jsonDeepParse } from 'src/app/functions/shared-functions';
import { getIP } from 'src/app/modules/jobseeker-registration/services/registration/jobseeker-registration.service';
import { ConfirmationComponent } from 'src/app/modules/shared/confirmation/confirmation.component';
import { FilesService } from 'src/app/services/shared/files/files.service';
import { NotificationService } from 'src/app/services/shared/notification/notification.service';
import { OnboardingDetailsService } from '../../services/onboarding-details/onboarding-details.service';

@Component({
  selector: 'app-appointment-details',
  templateUrl: './appointment-details.component.html',
  styleUrls: ['./appointment-details.component.scss'],
  providers: [OnboardingDetailsService, FilesService]
})
export class AppointmentDetailsComponent implements OnInit {

  @Output() formSaved = new EventEmitter();
  @Input() disable_action;
  @Input() first_login_details;

  terms_conditions = false;
  // session = new Session();
  sign_upload_type = 1;
  appointment_details;
  error_message = '';
  constructor(public appointment_details_srv: OnboardingDetailsService,
    private notification: NotificationService,
    private dialog: MatDialog,
    private file_srv: FilesService,
    private translate: TranslateService
  ) {

  }
  reset_embed_tag = true;
  resetCallbackRef

  digital_signature_form = new UntypedFormGroup({
    signature: new UntypedFormControl(null, [Validators.required])
  })




  ngOnInit() {
    this.resetCallbackRef = this.resetSign.bind(this)

    this.getAppointmentDetails()

  }

  resetSign() {
    this.digital_signature_form.reset();
    this.appointment_details.offerAcceptedSignature = null;
  }

  getAppointmentDetails() {
    this.appointment_details_srv.getAppointmentAcceptance().subscribe(res => {
      if (res && res['status']) {
        this.appointment_details = jsonDeepParse(res['data']);
        this.disable_action = this.appointment_details.appLetterAcceptance == 0 ? 1 : 0;;

        if (this.disable_action && this.appointment_details && this.appointment_details.offerAcceptedSignature) {
          let sign;
          if (this.appointment_details.offerAcceptedSignature && this.appointment_details.offerAcceptedSignature.length && typeof this.appointment_details.offerAcceptedSignature == 'object') {
            sign = this.appointment_details.offerAcceptedSignature
          }
          else if (this.appointment_details.offerAcceptedSignature && typeof this.appointment_details.offerAcceptedSignature == 'object') {
            sign = [this.appointment_details.offerAcceptedSignature];
          }

          if (sign) {
            this.digital_signature_form.get('signature').patchValue(sign);
          }
        }

        // this.appointment_details.cdnPath = '01df9975-8816-461e-b514-07bf998ceff5.pdf'
        this.getBase64(this.appointment_details.cdnPath, this.appointment_details)
      }
      else {
        this.error_message = res['message']
      }
    })
  }

  toggleSignatureType() {
    this.digital_signature_form.reset()
    if (this.sign_upload_type == 1) {
      this.sign_upload_type = 2;
    }
    else if (this.sign_upload_type == 2) {
      this.sign_upload_type = 1;
    }
  }

  getBase64(cdnPath, file) {

    this.reset_embed_tag = false;
    this.file_srv.getDocxBase64(cdnPath).subscribe(res => {

      if (res && res['data']) {
        file.fileData = 'data:application/pdf;base64,' + res['data'].filedata;
        setTimeout(() => {
          this.reset_embed_tag = true;
        })
      }
    })
  }


  termsConditions() {

  }

  submitAppointmentAcceptance(e) {
    if (e == 1) {
      if (!this.terms_conditions) {
        this.notification.error('Please accept the terms', 'close', 3000);

        return false;
      }

      if (this.digital_signature_form.invalid) {
        // this.notification.error('your signature', 'close', 3000);
        getInvalidFields(this.digital_signature_form, this.translate, this.notification, 'OFFER.');

        return false;
      }
    }
    this.dialog.open(ConfirmationComponent, {
      width: "480px",
      height: "auto",
      panelClass: "icr-dialog",
      data: {
        title: "ERROR.confirmation",
        message: "OFFER.are_you_sure_to_proceed",
        positive_button: "BTN.yes",
        negative_button: "BTN.no"
      },
    }).afterClosed().subscribe((action) => {
      if (action) {
        try {
          this.uploadSign(this.sign_upload_type).subscribe(res => {
            let offerAcceptedSignature = this.sign_upload_type == 1 ? (res ? res : null) : this.digital_signature_form.value.signature;
            let appointmentIP;
            try {
              appointmentIP = getIP().ip;
            } catch (error) {

            }
            this.appointment_details_srv.submitAppointmentAcceptance({ appointmentId: this.appointment_details.appointmentId, status: e, offerAcceptedSignature: offerAcceptedSignature, appointmentIP: appointmentIP }).subscribe(res => {
              if (res && res['status']) {
                this.notification.success(res['message'], 'close', 5000);
                this.formSaved.emit('true');
              }
              else {
                this.notification.error(res['message'], 'close', 5000);

              }
              // this.router.navigate(['/my-jobs']);
            })
          })
          //offerAcceptedSignature: this.digital_signature_form.value.signature

        }
        catch (err) { }
      }
    })
  }


  uploadSign(type) {
    return new Observable(obs => {
      // if (!(this.appointment_details && this.appointment_details.offerAcceptedSignature)) {
      if (type == 1) {
        let file = this.dataURLtoFile(this.digital_signature_form.value.signature, 'digital-sign.png')
        let form_data = new FormData();
        form_data.append('attachment', file, file.name);
        this.notification.success('FILES.uploading_attachments', 'Close', 3000);
        this.file_srv.uploadAttachment(form_data).subscribe(res => {

          let attach = {}
          if (res && res['data']) {

            attach['fileName'] = res['data']['a_fn'];
            attach['cdnPath'] = res['data']["a_url"];
            this.notification.success(res['message'], 'Close', 3000);
            obs.next(attach)
            // attach['width'] = this.result_dimentions[0].width
            // attach['height'] = this.result_dimentions[0].heigh
          }
          else {
            obs.next(0)
            this.notification.error(res && res['message'], 'Close', 3000);
          }
        }, err => {
          obs.next(0);
        })
      }
      else if (type == 2) {
        obs.next(1)
      }
      // }
      // else {
      //   obs.next(this.digital_signature_form.value.signature)
      // }
    })

  }

  dataURLtoFile(dataurl, filename) {
    var arr = dataurl.split(','),
      mime = arr[0].match(/:(.*?);/)[1],
      bstr = atob(arr[1]),
      n = bstr.length,
      u8arr = new Uint8Array(n);

    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }

    return new File([u8arr], filename, { type: mime });
  }
}
